import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { MeetingMinutesPreview } from "./MeetingMinutesPreview";
import type { Meeting } from "@repo/types";
import { Button } from "@repo/ui/components/Base/Button";
import { useNavigate } from "react-router-dom";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { MEETING_MOTIF } from "@/lib/constants";
import { useGetDocument } from "@/hooks/queryHooks/documentHooks";

export const MeetingMinutesPreviewDialog = ({
  tenantId,
  meeting,
  open,
  setOpen,
  handleCancel,
  handlePublish,
  handleCreateDocument,
}: {
  tenantId: string;
  meeting: Meeting;
  open: boolean;
  setOpen: (open: boolean) => void;
  handleCancel?: () => void;
  handlePublish?: () => void;
  handleCreateDocument?: () => void;
}) => {
  const navigate = useNavigate();
  const { data: documentData } = useGetDocument(
    tenantId,
    meeting.minutesData?.documentId ?? ""
  );
  const minutesDocumentId =
    documentData && !documentData._deleted ? documentData.id : null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader className={MEETING_MOTIF}>
          <DialogTitle>Meeting Minutes Preview</DialogTitle>
        </DialogHeader>
        <DialogBody className="h-[70vh]">
          <div className="flex flex-col gap-y-4 w-full h-full">
            <div className="flex-grow">
              <MeetingMinutesPreview meeting={meeting} />
            </div>
          </div>
        </DialogBody>
        <DialogFooter className="justify-between gap-x-4">
          <Button
            variant="destructive"
            onClick={() => {
              setOpen(false);
              handleCancel?.();
            }}
          >
            Cancel
          </Button>
          <div className="flex-grow" />
          {handlePublish && (
            <Button onClick={() => handlePublish()}>
              Publish Official Version
            </Button>
          )}
          {handleCreateDocument && (
            <Button
              tooltip={
                minutesDocumentId
                  ? "Minutes are already attached to a document"
                  : "Create new document for minutes"
              }
              onClick={() => handleCreateDocument()}
            >
              {minutesDocumentId
                ? "Add to Another Document"
                : "Add to New Document"}
            </Button>
          )}
          {minutesDocumentId && (
            <Button
              tooltip="View document for these minutes"
              onClick={() => {
                navigate(
                  new AppUrlPath(tenantId).getDocumentPath(minutesDocumentId)
                );
              }}
            >
              View Saved Minutes
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
